import { h } from 'preact';
import React from 'react';

import { getParameterByName } from './util';
import { CCPA_ORIGIN, MMS_ORIGIN } from './constants';

import './style.css';

const injectQueryParams = (Component) => (props) => (
  <Component
    {...props}
    messageId={getParameterByName('message_id')}
    dev={getParameterByName('type') === 'dev'}
    mini={getParameterByName('type') === 'mini'}
    tiny={getParameterByName('type') === 'tiny'}
    ccpaType={getParameterByName('ccpa_type')}
    accountId={getParameterByName('account_id') || 22}
    ccpaOrigin={getParameterByName('ccpa_origin') || CCPA_ORIGIN}
    mmsOrigin={getParameterByName('mms_origin') || MMS_ORIGIN}
    siteId={getParameterByName('site_id')}
    requestId={getParameterByName('request_id')}
  />
);

export default injectQueryParams;